import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { get } from "../../utils/apiManager";
import { baseURL } from "../../config/config";

const pill = (active) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 100, fontSize: 12, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
    <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
  </span>
);

const Row = ({ label, value }) => value !== undefined && value !== null && value !== '' ? (
  <div style={{ display: 'flex', padding: '11px 0', borderBottom: '1px solid #f0f2f8' }}>
    <div style={{ width: 160, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>{label}</div>
    <div style={{ fontSize: 14, color: '#0a1628' }}>{value}</div>
  </div>
) : null;

const ViewOne = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [category, setCategory] = useState({});

  useEffect(() => {
    if (location?.search) getOneCategory(location.search.split("?")[1]);
  }, []);

  const getOneCategory = (id) => {
    get(`/category/${id}`)
      .then((res) => setCategory(res?.datas || {}))
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden', maxWidth: 680 }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>View Category</h3>
          <button onClick={() => Navigate('/admin/category')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <div style={{ padding: '8px 28px 20px' }}>
          <Row label="Name" value={category?.name} />
          <Row label="Description" value={category?.description || '—'} />
          {category?.image && (
            <div style={{ display: 'flex', padding: '11px 0', borderBottom: '1px solid #f0f2f8' }}>
              <div style={{ width: 160, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Image</div>
              <img src={`${baseURL}/${category.image}`} alt="category" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: '1px solid #e2e8f0' }} />
            </div>
          )}
          {category?.icon && (
            <div style={{ display: 'flex', padding: '11px 0', borderBottom: '1px solid #f0f2f8' }}>
              <div style={{ width: 160, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Icon</div>
              <img src={`${baseURL}/${category.icon}`} alt="icon" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }} />
            </div>
          )}
          {category?.hasOwnProperty('isActive') && (
            <div style={{ display: 'flex', padding: '11px 0' }}>
              <div style={{ width: 160, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Status</div>
              {pill(category?.isActive)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
